import { AlertTriangle, Code, Layers, Eye, Gauge, Link2 } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

const problems = [
  {
    icon: Code,
    title: 'JavaScript Content Not Indexed',
    description: 'Search engines often skip content rendered only by client-side JavaScript, leaving pages invisible.',
  },
  {
    icon: Layers,
    title: 'SPA & PWA Problems',
    description: 'Single-page applications struggle with crawlability — bots see empty shells instead of rich content.',
  },
  {
    icon: Eye,
    title: 'Dynamic Rendering Failures',
    description: 'Client-side routing, lazy-loaded elements, and hydration mismatches confuse crawler pipelines.',
  },
  {
    icon: AlertTriangle,
    title: 'AI Cannot Interpret Content',
    description: 'LLMs like ChatGPT and Gemini may have zero knowledge of your brand if your pages lack structure.',
  },
  {
    icon: Gauge,
    title: 'Crawl Budget Waste',
    description: 'Bots spend their limited budget on duplicate, blocked, or low-value pages instead of your key content.',
  },
  {
    icon: Link2,
    title: 'Broken Internal Linking',
    description: 'Orphan pages and dead links prevent crawlers from discovering and prioritizing important content.',
  },
];

const ProblemSection = () => (
  <section className="py-20 md:py-24">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-cv-orange/10 text-cv-orange text-xs font-bold uppercase tracking-wider rounded-full border border-cv-orange/40 mb-4">
            The Problem
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-cv-navy mb-4">
            Why Your Website May Be <span className="text-cv-orange">Invisible</span> to Bots
          </h2>
          <p className="text-cv-navy/70 max-w-2xl mx-auto text-lg">
            Traditional tools miss what modern crawlers actually struggle with. These are the silent killers of search visibility.
          </p>
        </div>
      </ScrollReveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {problems.map((p, i) => (
          <ScrollReveal key={p.title} delay={i * 0.08}>
            <div className="bg-white border border-cv-navy/10 rounded-2xl p-6 h-full hover:shadow-lg hover:border-cv-orange/40 transition-all">
              <div className="w-11 h-11 rounded-xl bg-cv-orange/15 border border-cv-orange/40 flex items-center justify-center mb-4">
                <p.icon className="w-5 h-5 text-cv-orange" />
              </div>
              <h3 className="text-base font-bold text-cv-navy mb-2">{p.title}</h3>
              <p className="text-sm text-cv-navy/70 leading-relaxed">{p.description}</p>
            </div>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
);

export default ProblemSection;
